import { useState } from "react";

import { Button, Icon } from "@blueprintjs/core";

import { Tooltip } from "@/components/helpers/ui/blueprint-overrides/Tooltip";
import { Box, Flex } from "@/components/layout/flexbox";
import { Container } from "@/components/pieces/bootstrap";
import {
  FeatureIntroducedDocument,
  useIntroduceFeatureMutation,
} from "@/graphql";

const featureType = "HOW_TO_ROLEPLAY";

interface HowToRoleplayContentProps {
  onDismiss: () => void;
}

function HowToRoleplayContent({ onDismiss }: HowToRoleplayContentProps) {
  return (
    <Box
      className="bbs"
      backgroundColor="#FFF"
      py={3}
      css={{ position: "relative" }}
    >
      <Container>
        <Flex css={{ gap: 20 }}>
          <Flex
            flex={1}
            p={3}
            className="round-corners"
            style={{
              background:
                "linear-gradient(127deg, #F2FAFF 7.13%, #D8ECF8 102.77%)",
            }}
          >
            <Box fontWeight={500} width={20}>
              1.
            </Box>
            <Box ml={1}>
              <Box fontWeight={500}>Plan Your Convo</Box>
              <Box mt={1}>
                Read the context and use the notepad to plan your approach
              </Box>
            </Box>
          </Flex>
          <Flex
            flex={1}
            p={3}
            className="round-corners"
            style={{
              background:
                "linear-gradient(127deg, #F3FFF6 7.13%, #DAF7F9 102.77%)",
            }}
          >
            <Box fontWeight={500} width={20}>
              2.
            </Box>
            <Box ml={1}>
              <Box fontWeight={500}>Review Evaluation Criteria</Box>
              <Box mt={1}>
                To get the best score, you’ll need to address them all
              </Box>
            </Box>
          </Flex>
          <Flex
            flex={1}
            p={3}
            className="round-corners"
            style={{
              background:
                "linear-gradient(127deg, #F3F2FF 7.13%, #D8E5F8 102.77%)",
            }}
          >
            <Box fontWeight={500} width={20}>
              3.
            </Box>
            <Box ml={1}>
              <Box fontWeight={500}>Begin Your Session</Box>
              <Box mt={1}>
                Please use headphones and feel free to invent details!
              </Box>
            </Box>
          </Flex>
        </Flex>
      </Container>
      <Box style={{ position: "absolute", right: 16, top: 16 }}>
        <Tooltip content="Dismiss" placement="left">
          <Button
            minimal={true}
            icon={<Icon icon="cross" size={24} />}
            onClick={onDismiss}
          />
        </Tooltip>
      </Box>
    </Box>
  );
}

interface HowToRoleplayProps {
  show?: boolean;
  maxWidth?: number;
}

export function HowToRoleplay({ show = false }: HowToRoleplayProps) {
  const [submitted, setSubmitted] = useState(false);

  const [introduceFeature] = useIntroduceFeatureMutation({
    variables: { featureType },
    refetchQueries: [
      { query: FeatureIntroducedDocument, variables: { featureType } },
    ],
  });

  if (submitted || !show) return null;

  function submit() {
    setSubmitted(true);
    introduceFeature();
  }

  return <HowToRoleplayContent onDismiss={submit} />;
}
